<template>
    <LosesAutoItemEdit
            :objectType="'Auto'"
            :parentId="$route.params.parentId"
            :id="$route.params.id"
    />
</template>

<script>
    import LosesAutoItemEdit from "@/views/auto/LosesAutoItemEdit";
    export default {
        name: "loses-evaluation-auto",
        components: {LosesAutoItemEdit}
    }
</script>

<style scoped>

</style>